import { Link } from 'react-router-dom';

function ProfileSection() {
  const myProfileArray = [
    {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 24 24'
        >
          <path
            fill='currentColor'
            fillRule='evenodd'
            d='M8 7a4 4 0 1 1 8 0a4 4 0 0 1-8 0Zm0 6a5 5 0 0 0-5 5a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3a5 5 0 0 0-5-5H8Z'
            clipRule='evenodd'
          />
        </svg>
      ),
      title: 'My profile',
      body: 'See all user profile information',
      button: (
        <Link
          to='profile'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
        >
          view
        </Link>
      ),
    },
    {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 24 24'
        >
          <path
            fill='currentColor'
            d='M20 5a3 3 0 1 1-6 0a3 3 0 0 1 6 0ZM7 3a4 4 0 0 0-4 4v2h2V7a2 2 0 0 1 2-2h3V3H7Zm10 18a4 4 0 0 0 4-4v-2h-2v2a2 2 0 0 1-2 2h-3v2h3ZM7 16a3 3 0 1 0 0-6a3 3 0 0 0 0 6Zm10-7a4 4 0 0 0-4 4h8a4 4 0 0 0-4-4ZM3 21a4 4 0 0 1 8 0H3Z'
          />
        </svg>
      ),
      title: 'My Transaction Ratings',
      body: 'Ratings and review of each transaction you completed',
      button: (
        <Link
          to='ratings'
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-fit h-fit py-1.5 px-8 disabled:bg-b-mct bg-b-mc rounded relative'
        >
          view
        </Link>
      ),
    },
  ];
  return (
    <section>
      {' '}
      <div className='px-5 lg:px-32 py-4 md:py-8'>
        <h2 className='text-[18px] font-semibold pb-4'>My Profile</h2>
        {myProfileArray.map((data, index) => (
          <div
            className='flex flex-row gap-6 justify-between py-6 border-t-hf'
            key={index}
          >
            <div className='flex flex-row gap-4'>
              <p className='text-6xl text-s-bk stroke'>{data.icon}</p>
              <div className='flex flex-col '>
                <h4>{data.title}</h4>
                <p className='flex flex-row gap-2 items-center text- text-s-bk'>
                  {data.body}
                </p>
              </div>
            </div>
            {data.button}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProfileSection;
